const API_URL = '/api/success-payment-callback?jwt=';

export async function sitePrepareRequest(jwt) {
  const url = `${API_URL}${jwt}`;

  const response = await fetch(url, {
    method: 'post',
    body: '{}',
    headers: {
      'content-type': 'application/json',
    },
    redirect: 'follow',
    cache: 'no-cache',
  });

  const { success, errors } = await response.json();

  if (!success) {
    const [{ name, message }] = errors;
    const error = new Error(message);
    error.name = name;
    error.url = url;
    throw error;
  }
}
